import { render, staticRenderFns } from "./SingleList.vue?vue&type=template&id=5d638280"
import script from "./SingleList.vue?vue&type=script&lang=js"
export * from "./SingleList.vue?vue&type=script&lang=js"
import style0 from "./SingleList.vue?vue&type=style&index=0&id=5d638280&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports